module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/regenerator/index.js
// module id = 646
// module chunks = 0